import {where} from "firebase/firestore";
import {sumarPropiedadColeccionWheres} from "../../Servicios/BD/Contadores/sumarPropiedadColeccionWheres";

export const obtenerTotalBolsillos = async ({idUsuario}) => {


    let wheres =
        [
            where('idUsuario', '==', idUsuario),
            where('estado', '==', 'Aceptado'),
            where('tipo', 'in', ['Deposito', 'Rendimiento']),
        ]

    let dox = await sumarPropiedadColeccionWheres({coleccion: 'movimientos', wheres: wheres, propiedad: 'valor'})

    let totalDepositos = 0
    if (dox.res) {
        totalDepositos = dox.data
    } else {
        totalDepositos = 0
    }

    let wheresRetiros =
        [
            where('idUsuario', '==', idUsuario),
            where('tipo', '==', 'Retiro'),
        ]

    let doxReti = await sumarPropiedadColeccionWheres({
        coleccion: 'movimientos',
        wheres: wheresRetiros,
        propiedad: 'valor'
    })

    let totalRetiros = 0
    if (doxReti.res) {
        totalRetiros = doxReti.data
    } else {
        totalRetiros = 0
    }


    return totalDepositos - totalRetiros


}